export default __webpack_public_path__ + "static/media/Group4.94c2a124.svg";